import { UserData } from './types'

export function getBalanceForMarketUid(
  lender: string,
  marketUid: string,
  balances: { [lender: string]: UserData },
  subAccount?: string,
) {
  const accountPositions = balances?.[lender]?.data
  if (!accountPositions) return undefined
  if (accountPositions.length === 1)
    return accountPositions[0].positions.find((a) => a.marketUid === marketUid)
  return accountPositions
    .find((p) => p.accountId === subAccount!)
    ?.positions.find((a) => a.marketUid === marketUid)
}
